export enum EnActivityType {
    Activity  = 'Activity',
    List  = 'List',
    ListDetail  = 'ListDetail',
    StandAlone  = 'StandAlone',
    ProcessActivity  = 'ProcessActivity',
    AtividadeMultipla = 'AtividadeMultipla'
}
